import React, { useEffect, useState } from "react";
import UserCard from "../../components/Participants/UserCard";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllArchivedParticipants,
  getAllParticipants,
} from "../../redux/thunks/participants";
import axios from "../../libs/axios";
import toast from "react-hot-toast";
import { getYearOnly } from "../../utils/getYearOnly";
import { Link } from "react-router-dom";

const Participants = () => {
  const [selectedYear, setSelectedYear] = useState(0);
  const [years, setYears] = useState([]);
  const dispatch = useDispatch();
  const participants = useSelector((state) => state.participants);

  useEffect(() => {
    axios
      .get("/archive")
      .then((res) => setYears(res.data))
      .catch((err) => toast.error(err.resposne?.data?.message));
  }, []);

  useEffect(() => {
    if (selectedYear === 0) {
      dispatch(getAllParticipants({ hidden: false }));
    } else {
      dispatch(getAllArchivedParticipants({ date: selectedYear }));
    }
  }, [dispatch, selectedYear]);

  const handleYearChange = (year) => {
    setSelectedYear(year);
  };

  return (
    <div className="container mx-auto my-4 px-7">
      <div className="flex justify-center space-x-4 mb-4">
        <button
          className={`btn ${
            selectedYear === 0 ? "btn-primary" : "btn-neutral"
          }`}
          onClick={() => handleYearChange(0)}
        >
          წელს
        </button>
        {years?.map((year, _index) => {
          return (
            <button
              key={_index}
              className={`btn ${
                selectedYear === getYearOnly(year.date)
                  ? "btn-primary"
                  : "btn-neutral"
              }`}
              onClick={() => handleYearChange(getYearOnly(year.date))}
            >
              {getYearOnly(year.date)}
            </button>
          );
        })}
      </div>
      {participants && participants?.data?.length > 0 ? (
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {participants?.data?.map((user, i) => (
            <UserCard
              {...user}
              isNew={true}
              avatar_url={`${process.env.REACT_APP_EXPRESS_URL}${user.avatar_url}`}
              key={i}
            />
          ))}
        </div>
      ) : !selectedYear ? (
        <div className="card text-center">
          <h2 className="text-xl mt-7 font-bold">
            🔍 მონაწილეები არ მოიძებნა.
          </h2>
          <p className="mt-4">
            თუ გსურთ მონაწილეობის მიღება, გთხოვთ გაიაროთ{" "}
            <Link
              to="/register"
              className="btn btn-sm btn-primary ms-1 shadow-lg"
            >
              რეგისტრაცია
            </Link>
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Participants;
